<template>
    <v-container grid-list-md fluid>
        <!-- // first title row -->
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>

                    <v-col cols="11" class="d-flex align-center">
                        <h2>Rapprochements bancaires</h2>

                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>
                            <h3>
                                bobbee a une particularité : les mouvements bancaires ne sont pas
                                saisis, mais importés des données bancaire.
                            </h3>
                            <p class="mb-0">
                                Les paiements émis ou reçus, pas encore encaissés, n'apparaissent
                                pas dans les comptes 512, mais isolés dans des comptes d'attente.
                            </p>
                            <p class="mb-0">
                                En conséquence, le solde comptable et le solde du relevé bancaire
                                sont identiques.
                            </p>
                            <br />
                            <h4>Les seuls écarts possibles sont dus à :</h4>
                            <p class="mb-0">
                                - des écritures manuelles (ODs) qui mouvementent le compte 512 : il
                                vous faut alors modifier l'écriture et la passer dans le compte
                                d'attente correspondant
                            </p>
                            <p class="mb-0">- des mouvements importés plusieurs fois</p>
                            <p class="mb-0">- des mouvements manquants</p>
                            <br />
                            <h3>bobbee vous fournit plusieurs outils pour analyser cela :</h3>
                            <h4>- au niveau du rapprochement bancaire :</h4>
                            <div class="pl-4">
                                <h4 class="mb-0">
                                    - si l'écart de la dernière ligne est nul, le rapprochement est
                                    correct.
                                </h4>
                                <p class="mb-0">
                                    - dans le cas contraire, la colonne "Origine de l'écart" vous
                                    permet d'identifier la période à analyser
                                </p>
                                <p class="mb-0">
                                    - vous avez la possibilité d'insérer manuellement des soldes
                                    bancaires intermédiaires, afin d'affiner la recherche
                                </p>
                            </div>
                            <p class="mb-0">
                                - en cas de mouvements manquants, vous pouvez les importer via
                                <b>Banques - Import - csv ou xlsx</b>
                            </p>
                            <p class="mb-0">
                                - en cas de doublons, le chemin d'accès est le suivant :
                                <b
                                    >Banques - Filtres - Contrôles - Doublons avec libellé ou
                                    Doublons sans libellé</b
                                >
                            </p>
                            <!-- <p>
                                    <v-img src="../../../../README/imgs/docs/OssDatePicker-1.png" height="150px" width="150px" border="1px" alt="test" />
                                    <v-img src="https://en.wikipedia.org/wiki/HTML#/media/File:HTML5_logo_and_wordmark.svg"/>
                                </p> -->
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>

            <!-- // audit content -->
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            >
                            </v-btn>
                        </template>
                    </v-tooltip>

                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            >
                            </v-btn>
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="storeComments()"
                        data-cy="CheckBankReconciliation-save"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        data-cy="CheckBankReconciliation-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeComments('REVIEW');
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeComments('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            >
                            </v-btn-next>
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>

                    <!-- pipe character is rendered with a border -->
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                            color:'{{secondary}}'
                        "
                    />

                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>

                        <v-list nav>
                            <v-list-item
                                @click="displayActivityDialog = true"
                                :title="`Afficher l'activité`"
                            >
                                <template #append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>

        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- // * loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- // * no selected period -->
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- // * no created bankAccount -->
            <template v-else-if="!bankAccounts || !bankAccounts.length">
                <h4 class="pl-2 pt-2">Aucun compte bancaire</h4>
            </template>

            <template v-else>
                <!-- <p>bankAccounts : {{bankAccounts}}</p> -->
                <!-- // * closed period -->
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période Clôturée</h3>
                </v-row>

                <!-- // * bankAccounts -->
                <oss-data-table
                    :headers="headersBankAccounts"
                    :items="bankAccounts"
                    :striped="true"
                    :dense="true"
                    :loading="loading"
                    fixed-header
                    max-height="60vh"
                >
                    <!-- // * bankAccount name + iban + solde comptable + solde relevés + écart + validated -->
                    <template v-slot:item="{ item, index: bankAccountIndex }">
                        <tr
                            class="bankLine"
                            :key="item.id"
                            @click="addRemoveBankAccountExpanded(item)"
                        >
                            <td class="text-center" width="64px">
                                <v-icon :data-cy="'CheckBankReconciliation-chevron-' + item.id">
                                    {{
                                        isBankAccountExpanded(item)
                                            ? "$fa-chevron-up"
                                            : "$fa-chevron-down"
                                    }}
                                </v-icon>
                            </td>

                            <td class="text-left" v-if="item.name && item.iban">
                                <strong>{{ item.name }} - {{ item.iban }}</strong>
                            </td>

                            <td class="text-left" v-else-if="item.name && item.number">
                                <strong>{{ item.name }} - {{ item.number }}</strong>
                            </td>

                            <td class="text-left" v-else-if="item.name">
                                <strong>{{ item.name }}</strong>
                            </td>

                            <td class="text-left" v-else>
                                <strong>Pas de nom ou numéro de compte bancaire</strong>
                            </td>

                            <td class="text-right">
                                <h5 class="pl-4">
                                    {{
                                        newCommonFormatCurrency(
                                            item.generalLedgerBalance,
                                            undefined,
                                        )
                                    }}
                                </h5>
                            </td>

                            <td class="text-right">
                                <h5 class="pl-4">
                                    {{ newCommonFormatCurrency(item.importedBalance, undefined) }}
                                </h5>
                            </td>

                            <td class="text-right">
                                <h5 class="pl-4">
                                    {{
                                        newCommonFormatCurrency(item.manualJustification, undefined)
                                    }}
                                </h5>
                            </td>

                            <td class="text-right">
                                <h5
                                    class="pl-4"
                                    :class="item.balanceReconciliationFront ? 'text-error' : ''"
                                >
                                    {{
                                        newCommonFormatCurrency(
                                            item.balanceReconciliationFront,
                                            undefined,
                                        )
                                    }}
                                </h5>
                            </td>

                            <td class="text-center">
                                <!-- // ** icon more_vert(ical) with upsert + deleteACR -->

                                <!-- // // start -->
                                <v-menu offset-y>
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            icon="$dots_vertical"
                                            v-bind="props"
                                            class="mx-1"
                                            color="secondary"
                                            data-cy="CheckBankReconciliation-moreVert"
                                        />
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            :disabled="
                                                closedPeriod &&
                                                (!item.auditCheckResults ||
                                                    !item.auditCheckResults[0] ||
                                                    !item.auditCheckResults[0].id)
                                            "
                                            title="Supprimer les justifications manuelles et les
                                                commentaires"
                                            @click="
                                                deleteAuditCheckResult(item.auditCheckResults[0].id)
                                            "
                                            data-cy="CheckBankReconciliation-supprimerJustificatifs"
                                        >
                                            <template #append>
                                                <v-icon size="small"> $oss-trash </v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </td>

                            <td class="text-center">
                                <v-icon v-if="item.validated" color="primary">
                                    $check_circle
                                </v-icon>
                            </td>
                        </tr>

                        <tr v-if="isBankAccountExpanded(item)" class="px-0">
                            <td colspan="100" class="px-0">
                                <!-- ** bankAccount GL 512000 AccountableAccountBalanceDetail -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    @click="addRemoveBankAccountGL(item)"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-icon
                                            size="small"
                                            :icon="
                                                !isBankAccountGLExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                        />
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        Ecritures déjà encaissées (c/512000) (I)
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        {{
                                            newCommonFormatCurrency(
                                                item.generalLedgerBalance,
                                                undefined,
                                            )
                                        }}
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-show="isBankAccountGLExpanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <AccountableAccountBalanceDetail
                                            v-if="accountableAccountInfo"
                                            v-bind:companyId="companyId"
                                            v-bind:accountingPeriodId="accountingPeriodId"
                                            v-bind:accountableAccountInfo="
                                                accountableAccountInfo(
                                                    item.name,
                                                    item.accountableAccountName,
                                                )
                                            "
                                            v-bind:notReconciliated="withoutLettering"
                                            v-bind:withoutBank="withoutBank"
                                            v-bind:withoutDocument="withoutDocument"
                                            v-bind:inAccountingTransactions="accountingTransactions"
                                        >
                                        </AccountableAccountBalanceDetail>
                                        <!-- v-bind:selectedAccountingLineId="selectedAccountingLineId" -->
                                        <!-- @query-done="bankAccount512000OnQueryDone" -->
                                    </v-col>
                                </v-row>

                                <v-divider />

                                <!-- // * bankAccount balances (relevés bancaires) -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    @click="addRemoveBankAccountBalances(item)"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-icon
                                            size="small"
                                            data-cy="CheckBankReconciliation-soldeDernierReleverBancaire"
                                            :icon="
                                                !isBankAccountBalancesExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                        />
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        Solde dernier relevé bancaire (II)
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        {{
                                            newCommonFormatCurrency(item.importedBalance, undefined)
                                        }}
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <!-- ** balances expanded -->
                                <v-row
                                    no-gutters
                                    v-if="isBankAccountBalancesExpanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <v-card
                                            style="background: #f4f4f4"
                                            :key="refreshKey"
                                            elevation="0"
                                            class="pa-4"
                                        >
                                            <v-data-table
                                                :headers="headersBalancesTable"
                                                :items="item.balances"
                                                :striped="true"
                                                :dense="true"
                                                :fixed-header="true"
                                                height="40vh"
                                            >
                                                <!-- // ossDataTable dont handle header.checkbox  -->
                                                <!-- // 2024-12-10 waiting for Romain code -->
                                                <template v-slot:header.checkbox>
                                                    <v-checkbox
                                                        class="pa-0 ma-0 mr-1"
                                                        :ripple="false"
                                                        hide-details
                                                        v-model="allAreSelected"
                                                        @click="selectAll(item)"
                                                    />
                                                </template>
                                                <!-- :height="'calc(100vh - 350px)'" -->
                                                <template
                                                    v-slot:item="{
                                                        item: balance,
                                                        index: balanceIndex,
                                                    }"
                                                >
                                                    <tr>
                                                        <!-- // ** CHECKBOX -->
                                                        <td>
                                                            <v-checkbox
                                                                v-if="
                                                                    item.id &&
                                                                    balance.selected &&
                                                                    balance.selected.id &&
                                                                    balance.selected.type ===
                                                                        'MANUAL'
                                                                "
                                                                hide-details
                                                                class="pa-0 ma-0 mr-1"
                                                                v-model="balance.selected.checked"
                                                                :value="balance.selected.checkBoxId"
                                                                @click.stop="
                                                                    selectBalance(item, balance)
                                                                "
                                                            />
                                                            <!-- v-model="selectedBankReconciliationCheckBox" -->
                                                        </td>

                                                        <!-- // ** date -->
                                                        <td class="mr-6">
                                                            {{ formatDate(balance.date) }}
                                                        </td>

                                                        <!-- // ** type -->
                                                        <td class="mr-6">
                                                            <v-row no-gutters>
                                                                <v-col cols="2">
                                                                    <v-btn-icon
                                                                        icon="$remove_red_eye"
                                                                        v-if="
                                                                            balanceIndex >= 0 &&
                                                                            balance &&
                                                                            balance.selected &&
                                                                            balance.selected.type !=
                                                                                'MANUAL'
                                                                        "
                                                                        color="primary"
                                                                        @click.stop="
                                                                            showBTs(
                                                                                item,
                                                                                balanceIndex,
                                                                            )
                                                                        "
                                                                    />
                                                                    <v-btn-icon
                                                                        icon="$remove_red_eye"
                                                                        v-else
                                                                        disabled
                                                                    />
                                                                </v-col>

                                                                <v-col class="d-flex align-center">
                                                                    <template
                                                                        v-if="
                                                                            balance &&
                                                                            balance.balances &&
                                                                            balance.balances.length
                                                                        "
                                                                    >
                                                                        <v-select-filled
                                                                            v-if="
                                                                                balance.balances
                                                                                    .length > 1
                                                                            "
                                                                            v-model="
                                                                                balance.selected
                                                                            "
                                                                            :items="
                                                                                balance.balances
                                                                            "
                                                                            :item-title="
                                                                                getBalanceTypeText
                                                                            "
                                                                            return-object
                                                                            outlined
                                                                            hide-details
                                                                            @update:model-value="
                                                                                selectedBalanceChanged(
                                                                                    balance,
                                                                                )
                                                                            "
                                                                            :readonly="
                                                                                balance.balances
                                                                                    .length === 1
                                                                            "
                                                                            density="compact"
                                                                        />

                                                                        <div
                                                                            v-else-if="
                                                                                balance.balances
                                                                                    .length === 1
                                                                            "
                                                                        >
                                                                            {{
                                                                                getBalanceTypeText(
                                                                                    balance.selected,
                                                                                )
                                                                            }}
                                                                        </div>
                                                                    </template>
                                                                </v-col>
                                                            </v-row>
                                                        </td>

                                                        <!-- // ** Solde Compta -->
                                                        <td class="mr-6">
                                                            <div class="text-right">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        balance.glBalance,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </div>
                                                        </td>

                                                        <!-- // ** Solde Relevé  -->
                                                        <td class="mr-6">
                                                            <div
                                                                class="text-right"
                                                                v-if="
                                                                    balance &&
                                                                    balance.selected &&
                                                                    balance.selected.balance
                                                                "
                                                            >
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        balance.selected.balance,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </div>

                                                            <div class="text-right" v-else>-</div>
                                                        </td>

                                                        <!-- // ** Justificatifs manuels  -->
                                                        <!-- <td class="mr-6">
                                                            <div class="text-right">
                                                                >>{{ newCommonFormatCurrency(balance.manualJustification, undefined) }}
                                                            </div>
                                                        </td> -->

                                                        <!-- // ** Ecart -->
                                                        <td class="mr-6">
                                                            <div
                                                                v-if="balance.selected.balance"
                                                                class="text-right"
                                                                :style="
                                                                    differenceColor(
                                                                        balance.selected.balance,
                                                                        balance.glBalance,
                                                                    )
                                                                "
                                                            >
                                                                <strong>
                                                                    {{
                                                                        difference(
                                                                            balance.selected
                                                                                .balance,
                                                                            balance.glBalance,
                                                                        )
                                                                    }}
                                                                </strong>
                                                            </div>

                                                            <div v-else class="text-right">-</div>
                                                        </td>

                                                        <!-- // ** Origine de l'écart -->
                                                        <!-- <td class="mr-6"> -->
                                                        <!-- <p>item.balances[balanceIndex] : {{item.balances[balanceIndex]}}</p> -->
                                                        <!-- <p>balanceIndex : {{balanceIndex}}</p> -->
                                                        <!-- <p>deltaPreviousMonth(item.balances, balanceIndex) : {{deltaPreviousMonth(item.balances, balanceIndex)}}</p> -->
                                                        <!-- <div
                                                                class="text-right"
                                                            >
                                                                <strong>
                                                                    **{{ newCommonFormatCurrency(deltaPreviousMonth(item.balances, balanceIndex), undefined) }}
                                                                </strong>
                                                            </div>
                                                        </td> -->

                                                        <!-- // ** actions -->
                                                        <td>
                                                            <!-- <v-menu offset-y v-if="!isDuplicate(balance.selected, item)"> -->
                                                            <div
                                                                class="d-flex align-center text-center"
                                                            >
                                                                <v-btn-trash
                                                                    v-if="
                                                                        balance.selected &&
                                                                        balance.selected.id &&
                                                                        (balance.selected.type ===
                                                                            'MANUAL' ||
                                                                            balance.selected
                                                                                .type ===
                                                                                'IMPORT_TXT')
                                                                    "
                                                                    color="primary"
                                                                    @click="
                                                                        openBankReconciliationDialog(
                                                                            item,
                                                                            balance.selected.id,
                                                                        )
                                                                    "
                                                                />

                                                                <v-btn-trash v-else disabled />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>

                                            <!-- oss Band Reconciliation Dialog -->
                                            <oss-dialog
                                                v-if="deleteBankReconciliationDialog"
                                                v-model="deleteBankReconciliationDialog"
                                                title="Supprimer le solde relevé"
                                                @valid="
                                                    deleteSingleManualBalance(toDeleteBankBalanceId)
                                                "
                                                :validTitle="'Oui je suis sûr(e)'"
                                                min-width="800px"
                                            >
                                                <h4 class="text-center">
                                                    &#xca;tes-vous sûr(e) de vouloir le supprimer ?
                                                </h4>
                                            </oss-dialog>

                                            <oss-dialog
                                                v-if="deleteAllSelectionnedBankReconciliationDialog"
                                                v-model="
                                                    deleteAllSelectionnedBankReconciliationDialog
                                                "
                                                title="Supprimer les soldes manuels"
                                                @valid="deleteAllManualBalances()"
                                                :validTitle="'Oui je suis sûr(e)'"
                                                min-width="800px"
                                            >
                                                <h4 class="text-center">
                                                    &#xca;tes-vous sûr(e) de vouloir les supprimer ?
                                                </h4>
                                            </oss-dialog>

                                            <!-- // ** btns add reconciliation + 3 * goto + OD -->
                                            <v-row
                                                no-gutters
                                                class="pa-4 d-flex justify-space-between"
                                            >
                                                <v-col class="mr-4">
                                                    <v-btn
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        @click.stop="
                                                            newManualBalanceDialog =
                                                                !newManualBalanceDialog
                                                        "
                                                        class="d-inline px-2"
                                                        data-cy="CheckBankReconciliation-addSoldeManuelReleverBancaire"
                                                        size="small"
                                                    >
                                                        Ajouter un solde manuel de relevé bancaire
                                                    </v-btn>

                                                    <oss-dialog
                                                        v-if="newManualBalanceDialog"
                                                        v-model="newManualBalanceDialog"
                                                        title="Ajouter un solde manuel de relevé bancaire"
                                                        class="pa-4"
                                                        min-width="50vw"
                                                    >
                                                        <v-row no-gutters class="pa-4">
                                                            <v-col class="pr-4" cols="6">
                                                                <oss-date-picker-filled
                                                                    v-model="item.newBalanceDate"
                                                                    :minDate="
                                                                        accountingPeriod.start
                                                                    "
                                                                    :maxDate="accountingPeriod.end"
                                                                    hide-details
                                                                    :textFieldReadOnly="false"
                                                                    data-cy="CheckBankReconciliation-date"
                                                                />
                                                                <!-- @change-date="onNewBalanceDateChanged($event)" -->
                                                            </v-col>

                                                            <v-col cols="6">
                                                                <oss-text-field-filled
                                                                    v-model="item.newBalance"
                                                                    label="Nouveau solde"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    data-cy="CheckBankReconciliation-solde"
                                                                />
                                                            </v-col>

                                                            <v-spacer />

                                                            <v-col
                                                                class="d-flex align-center"
                                                                cols="3"
                                                            >
                                                            </v-col>
                                                        </v-row>

                                                        <template v-slot:actions>
                                                            <v-btn-primary
                                                                :disabled="disabledNewBalance(item)"
                                                                rounded
                                                                block
                                                                @click="addNewBalance(item)"
                                                                data-cy="CheckBankReconciliation-valid"
                                                                size="x-large"
                                                            >
                                                                Ajouter
                                                                <!-- <v-icon>$add</v-icon> -->
                                                            </v-btn-primary>
                                                            <!-- <v-btn
                                                                size="small"
                                                                rounded
                                                                :disabled="disabledNewBalance(item)"
                                                                elevation="0"

                                                                color="primary"
                                                                @click="addNewBalance(item)"

                                                            >
                                                                Ajouter
                                                                <v-icon>$add</v-icon>
                                                            </v-btn> -->
                                                        </template>
                                                    </oss-dialog>
                                                </v-col>

                                                <!-- // ** goTo Banques -->
                                                <v-col class="mr-4">
                                                    <v-btn
                                                        v-if="item.balanceReconciliation"
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        @click="$router.push({ name: 'bank' })"
                                                        size="small"
                                                    >
                                                        Banques - import
                                                    </v-btn>

                                                    <v-btn
                                                        v-else
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        Banques - import
                                                    </v-btn>
                                                </v-col>

                                                <!-- // ** goTo bank, params auditCheck: 'CheckBTDoublon -->
                                                <v-col class="mr-4">
                                                    <v-btn
                                                        :disable="!item.balanceReconciliation"
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        @click="
                                                            $router.push({
                                                                name: 'bank',
                                                                query: {
                                                                    auditCheck: 'CheckBTDoublon',
                                                                },
                                                            })
                                                        "
                                                        size="small"
                                                    >
                                                        Doublons avec libéllés
                                                    </v-btn>
                                                </v-col>

                                                <!-- // ** goTo bank, params auditCheck: 'CheckBTDoublonWithoutWording' -->
                                                <v-col class="mr-4">
                                                    <v-btn
                                                        v-if="item.balanceReconciliation"
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        @click="
                                                            $router.push({
                                                                name: 'bank',
                                                                query: {
                                                                    auditCheck:
                                                                        'CheckBTDoublonWithoutWording',
                                                                },
                                                            })
                                                        "
                                                        size="small"
                                                    >
                                                        Doublons sans libéllés
                                                    </v-btn>

                                                    <v-btn
                                                        v-else
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        Doublons sans libéllés
                                                    </v-btn>
                                                </v-col>

                                                <v-col>
                                                    <v-btn
                                                        v-if="
                                                            selectedBankReconciliationCheckBox.length ===
                                                            0
                                                        "
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        Supprimer les soldes manuels
                                                    </v-btn>

                                                    <v-btn
                                                        v-else
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        @click.stop="
                                                            deleteAllSelectionnedBankReconciliationDialog = true
                                                        "
                                                        size="small"
                                                    >
                                                        Supprimer les soldes manuels
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-divider />

                                <!-- // ** justificationLines - manualJustification -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    class="py-2"
                                    @click="addRemoveBankAccountManualJustification(item)"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-icon
                                            size="small"
                                            data-cy="CheckBankReconciliation-justificationsManuelles"
                                            :icon="
                                                !isBankAccountManualJustificationExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                        />
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        Justifications manuelles (III)
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        {{
                                            newCommonFormatCurrency(
                                                item.manualJustification,
                                                undefined,
                                            )
                                        }}
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <!-- ** manualJustification expanded -->
                                <v-row
                                    no-gutters
                                    v-if="isBankAccountManualJustificationExpanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <v-card
                                            v-if="
                                                item &&
                                                (item.balanceReconciliationFront ||
                                                    (item.justificationLines &&
                                                        item.justificationLines.length))
                                            "
                                            style="background: #f4f4f4"
                                            class="pa-4"
                                            :key="refreshKey"
                                            elevation="0"
                                        >
                                            <v-form v-model="formIsValid">
                                                <!-- // ** justificationLines - manualJustification -->
                                                <div
                                                    v-for="(
                                                        justif, index
                                                    ) in item.justificationLines"
                                                    :key="index"
                                                >
                                                    <v-row no-gutters class="mx-2">
                                                        <!-- // * date -->
                                                        <v-col class="pb-2" cols="3">
                                                            <oss-date-picker
                                                                v-model="justif.date"
                                                                :filterWithoutClosedAccountingPeriods="
                                                                    true
                                                                "
                                                                hide-details
                                                                :textFieldReadOnly="false"
                                                                :rules="[
                                                                    (v) =>
                                                                        v !== '' ||
                                                                        moment(v).isValid() ||
                                                                        $t(
                                                                            'settings.shared.errorDate',
                                                                        ),
                                                                ]"
                                                                required
                                                            >
                                                            </oss-date-picker>
                                                            <!-- textFieldClass="oss-" -->
                                                        </v-col>

                                                        <v-spacer />

                                                        <!-- // * debit -->
                                                        <v-col cols="2" class="pl-2 pb-2">
                                                            <oss-text-field
                                                                v-model="justif.debit"
                                                                outlined
                                                                :hide-details="true"
                                                                label="Débit"
                                                                @change="
                                                                    manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                        'debit',
                                                                    )
                                                                "
                                                                suffix="&#x20ac;"
                                                                single-line
                                                                dense
                                                                data-cy="CheckBankReconciliation-debit"
                                                            />
                                                            <!-- content-class="oss-" -->
                                                            <!-- :rules="[
                                                                    v => (v !== '' && (parseFloat(v) >= 0.0)) || $t('settings.positiveNumber'),
                                                                    v => (justif.debit > 0 || justif.credit > 0) || 'Saisie de débit ou crédit obligatoire'
                                                                ]" -->
                                                        </v-col>

                                                        <!-- // * credit -->
                                                        <v-col cols="2" class="pl-2 pb-2">
                                                            <oss-text-field
                                                                v-model="justif.credit"
                                                                outlined
                                                                :hide-details="true"
                                                                label="Crédit"
                                                                @change="
                                                                    manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                        'credit',
                                                                    )
                                                                "
                                                                suffix="&#x20ac;"
                                                                single-line
                                                                dense
                                                            />
                                                            <!-- :rules="[
                                                                    v => (v !== '' && parseFloat(v) >= 0.0) || $t('settings.positiveNumber'),
                                                                    v => (justif.debit > 0 || justif.credit > 0) || 'Saisie de débit ou crédit obligatoire'
                                                                ]" -->
                                                        </v-col>

                                                        <v-col cols="1" />
                                                    </v-row>

                                                    <v-row no-gutters>
                                                        <!-- // * wording -->
                                                        <v-col cols="11" class="pl-2 pb-2">
                                                            <v-textarea
                                                                outlined
                                                                :hide-details="true"
                                                                label="Libellé"
                                                                v-model="justif.wording"
                                                                :disabled="
                                                                    closedPeriod || validated
                                                                "
                                                                auto-grow
                                                                rows="1"
                                                                @change="
                                                                    manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        'Libellé obligatoire',
                                                                ]"
                                                                required
                                                                data-cy="CheckBankReconciliation-libelle"
                                                            />
                                                        </v-col>

                                                        <v-col
                                                            cols="1"
                                                            class="d-flex align-end text-center px-2 pb-2"
                                                        >
                                                            <v-row>
                                                                <!-- // * add -->
                                                                <v-col
                                                                    cols="6"
                                                                    class="text-center pl-2 pb-2"
                                                                >
                                                                    <v-btn-icon
                                                                        icon="$add"
                                                                        color="primary"
                                                                        @click="addEmptyRow(item)"
                                                                    />
                                                                </v-col>

                                                                <v-col
                                                                    cols="6"
                                                                    class="text-center pl-2 pb-2"
                                                                >
                                                                    <v-btn-trash
                                                                        @click="
                                                                            deleteRow(item, index)
                                                                        "
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>

                                                    <v-divider
                                                        v-if="!!item.justificationLines[index + 1]"
                                                        class="pb-2"
                                                    />
                                                </div>
                                            </v-form>

                                            <v-row no-gutters class="pt-4">
                                                <v-col
                                                    class="pl-2"
                                                    v-if="item.balanceReconciliationFront"
                                                    style="color: red"
                                                >
                                                    Reste à justifier
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -item.balanceReconciliationFront,
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                </v-col>
                                                <v-spacer />

                                                <v-col cols="auto" class="text-right">
                                                    <!-- <p>disabled</p> -->
                                                    <!-- <p>closedPeriod : {{closedPeriod}}</p> -->
                                                    <!-- <p>validated : {{validated}}</p> -->

                                                    <!-- <p>activated</p> -->
                                                    <!-- <p>formIsValid2(item) : {{formIsValid2(item)}}</p> -->
                                                    <!-- <p>!item.balanceReconciliationFront : {{!item.balanceReconciliationFront}}</p> -->

                                                    <v-btn
                                                        v-if="closedPeriod || validated"
                                                        disabled
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        class="d-inline px-2"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>

                                                    <v-btn
                                                        v-else-if="
                                                            formIsValid2(item) &&
                                                            !item.balanceReconciliationFront
                                                        "
                                                        @click.stop="createReconciliationData(item)"
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        class="d-inline px-2"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>

                                                    <v-btn
                                                        v-else
                                                        disabled
                                                        dense
                                                        rounded
                                                        elevation="0"
                                                        class="d-inline px-2"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>

                                                <v-col cols="1" />
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-divider />

                                <!-- // ** gap -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    class="py-2"
                                    :class="item.balanceReconciliationFront ? 'text-error' : ''"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-10" cols="1"> </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        <h4>ECART (I - (II + III))</h4>
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        <h4>
                                            {{
                                                newCommonFormatCurrency(
                                                    item.balanceReconciliationFront,
                                                    undefined,
                                                )
                                            }}
                                        </h4>
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-divider />

                                <!-- // ** 589999 AccountableAccountBalanceDetail -->
                                <v-row
                                    v-if="item.balance512999"
                                    no-gutters
                                    style="width: 100%"
                                    @click="addRemoveBankAccount512999(item)"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-btn
                                            icon
                                            style="width: 40px"
                                            class="d-inline px-2"
                                            @click="addRemoveBankAccount589999(item)"
                                            v-if="item.balance589999"
                                        >
                                            <v-icon small>
                                                {{
                                                    !isBankAccount589999Expanded(item)
                                                        ? "fa-chevron-up"
                                                        : "fa-chevron-down"
                                                }}
                                            </v-icon>
                                        </v-btn>

                                        <v-btn
                                            icon
                                            style="width: 40px"
                                            class="d-inline px-2"
                                            disabled
                                            v-else
                                        >
                                            <v-icon small>
                                                {{
                                                    !isBankAccount589999Expanded(item)
                                                        ? "fa-chevron-up"
                                                        : "fa-chevron-down"
                                                }}
                                            </v-icon>
                                        </v-btn>
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        Ecritures en attente d'encaissement (c/589999) (IV)
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        {{ newCommonFormatCurrency(item.balance589999, undefined) }}
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-show="isBankAccount589999Expanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <AccountableAccountBalanceDetail
                                            v-if="accountableAccountInfo"
                                            v-bind:companyId="companyId"
                                            v-bind:accountingPeriodId="accountingPeriodId"
                                            v-bind:accountableAccountInfo="
                                                accountableAccountInfo(
                                                    item.name,
                                                    item.accountableAccount999,
                                                )
                                            "
                                            v-bind:notReconciliated="withoutLettering"
                                            v-bind:withoutBank="withoutBank"
                                            v-bind:withoutDocument="withoutDocument"
                                            v-bind:inAccountingTransactions="accountingTransactions"
                                        >
                                        </AccountableAccountBalanceDetail>
                                        <!-- v-bind:selectedAccountingLineId="selectedAccountingLineId" -->
                                        <!-- @query-done="bankAccount589999OnQueryDone" -->
                                    </v-col>
                                </v-row>

                                <v-divider />

                                <!-- // ** bankAccount theoretic accounting balance -->
                                <v-row
                                    v-if="item.balance512999"
                                    no-gutters
                                    style="width: 100%"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-10" cols="1" />

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        <h4><i> SOLDE COMPTABLE GLOBAL (I + IV) </i></h4>
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4 justify-end" cols="1">
                                        <h4>
                                            <i>
                                                {{
                                                    newCommonFormatCurrency(
                                                        item.accountingTheoreticBalance,
                                                        undefined,
                                                    )
                                                }}
                                            </i>
                                        </h4>
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-divider />

                                <!-- // ** comments -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    @click="addRemoveBankAccountComment(item)"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-icon
                                            size="small"
                                            :icon="
                                                !isBankAccountCommentExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                        />
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        <b v-if="item.comment">Commentaires détaillés</b>
                                        <template v-else>Commentaires détaillés</template>
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-if="isBankAccountCommentExpanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <v-card
                                            style="background: #f4f4f4; border-radius: 16px"
                                            class="pa-4"
                                            :key="refreshKey"
                                            elevation="0"
                                        >
                                            <v-row no-gutters>
                                                <v-col>
                                                    <v-card-text style="padding: 0">
                                                        <v-textarea
                                                            class="pt-0 pb-4"
                                                            v-model="item.comment"
                                                            :disabled="closedPeriod || validated"
                                                            auto-grow
                                                            rows="1"
                                                            outlined
                                                            hide-details
                                                            dense
                                                        />
                                                        <!-- :key="i" -->
                                                    </v-card-text>
                                                </v-col>
                                            </v-row>

                                            <v-row no-gutters>
                                                <v-col style="padding-bottom: 0">
                                                    <v-card-title class="pa-0">
                                                        <v-spacer />

                                                        <!-- // ** Store data -->
                                                        <v-btn
                                                            v-if="closedPeriod || validated"
                                                            disabled
                                                            rounded
                                                            class="btn btn_blue"
                                                            size="small"
                                                        >
                                                            Enregistrer
                                                        </v-btn>
                                                        <v-btn
                                                            v-else
                                                            rounded
                                                            class="btn btn_blue"
                                                            @click.stop="
                                                                createReconciliationData(item)
                                                            "
                                                            size="small"
                                                        >
                                                            Enregistrer
                                                        </v-btn>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-divider />

                                <!-- // ** shortComment -->
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                    @click="addRemoveBankAccountShortComment(item)"
                                    class="py-2"
                                >
                                    <v-col class="d-flex align-center pt-0 pl-8" cols="1">
                                        <v-icon size="small">
                                            {{
                                                !isBankAccountShortCommentExpanded(item)
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"
                                            }}
                                        </v-icon>
                                    </v-col>

                                    <v-col class="d-flex align-center pl-4" cols="3">
                                        <b v-if="item.shortComment">Commentaires synthétiques</b>
                                        <template v-else>Commentaires synthétiques</template>
                                    </v-col>

                                    <v-spacer />
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-if="isBankAccountShortCommentExpanded(item)"
                                    style="width: 100%"
                                    class="px-4 pb-4"
                                >
                                    <v-col cols="12">
                                        <v-card
                                            style="background: #f4f4f4; border-radius: 16px"
                                            class="pa-4"
                                            :key="refreshKey"
                                            elevation="0"
                                        >
                                            <v-row no-gutters>
                                                <v-col>
                                                    <v-card-text style="padding: 0">
                                                        <v-textarea
                                                            class="pt-0 pb-4"
                                                            v-model="item.shortComment"
                                                            :disabled="closedPeriod || validated"
                                                            auto-grow
                                                            rows="1"
                                                            outlined
                                                            hide-details
                                                            dense
                                                        />
                                                        <!-- :key="i" -->
                                                    </v-card-text>
                                                </v-col>
                                            </v-row>

                                            <v-row no-gutters>
                                                <v-col style="padding-bottom: 0">
                                                    <v-card-title class="pa-0">
                                                        <v-spacer />

                                                        <!-- // ** Store data -->
                                                        <v-btn
                                                            v-if="closedPeriod || validated"
                                                            disabled
                                                            rounded
                                                            class="btn btn_blue"
                                                            size="small"
                                                        >
                                                            Enregistrer
                                                        </v-btn>
                                                        <v-btn
                                                            v-else
                                                            rounded
                                                            class="btn btn_blue"
                                                            @click.stop="
                                                                createReconciliationData(item)
                                                            "
                                                            size="small"
                                                        >
                                                            Enregistrer
                                                        </v-btn>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </td>
                        </tr>
                    </template>
                </oss-data-table>

                <!-- // ** 512 GeneralLedger -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="auto" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Autres disponibilités - comptes
                                    {{
                                        getTextFromStringArray(auditItems.othersAccountableAccounts)
                                    }}
                                    (sauf
                                    {{
                                        getTextFromStringArray(
                                            auditItems.excludedOthersAccountableAccounts,
                                        )
                                    }})
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="auto" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    {{ newCommonFormatCurrency(generalLedgerOthers, undefined) }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-centerjustify-center">
                            <v-row>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <v-card
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <GeneralLedger
                                        ref="generalLedger"
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriodId"
                                        :accountableAccountFilter="
                                            auditItems.othersAccountableAccounts
                                        "
                                        :excludedAccountableAccountFilter="
                                            auditItems.excludedOthersAccountableAccounts || []
                                        "
                                        :inNm1="false"
                                        :hideOptions="true"
                                        :enableAuditedAccountableAccounts="true"
                                        @query-done="onQueryDone"
                                    />
                                </v-col>
                            </v-row>

                            <!-- // ** OD -->
                            <v-row no-gutters>
                                <v-col style="padding-bottom: 0">
                                    <v-card-title
                                        style="
                                            padding-top: 20px;
                                            padding-bottom: 0;
                                            padding-left: 0;
                                        "
                                    >
                                        <v-spacer />

                                        <!-- <v-btn
                                            v-if="closedPeriod || validated"
                                            rounded
                                             size="small"
                                            disabled
                                        >
                                            OD
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            rounded
                                             size="small"

                                            color="primary"
                                            class="btn btn_blue"
                                            @click="createReconciliationData(item);miscellanousOperationData = undefined;miscellaneousOperationDialog=true;"
                                        >
                                            OD
                                        </v-btn> -->
                                    </v-card-title>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card-text>
                </v-card>
            </template>

            <!-- // ** connectedDocuments -->
            <template v-if="!loading && !dataLoading">
                <AuditConnectedAcrDocuments
                    :connectedDocuments="connectedDocuments"
                    :companyId="companyId"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    @unlinkedDocument="unlinkDocument($event)"
                    @showLinkedDocument="showLinkedDocument($event)"
                />
            </template>

            <!-- // ** results -->
            <template v-if="!loading && !dataLoading">
                <AuditConnectedAcrResults :results="results" :companyId="companyId" />
            </template>

            <!-- // ++ longComment -->
            <v-card
                elevation="0"
                style="background-color: white; border-radius: 25px"
                class="pa-6 mt-4"
            >
                <v-row>
                    <v-col cols="5" class="ma-auto">
                        <v-card-title class="ma-0 pa-0">
                            <h5 class="pl-4">Commentaires détaillés</h5>
                        </v-card-title>
                    </v-col>

                    <v-spacer />

                    <!-- // ** icons *************** -->
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center pa-0">
                                <!-- <v-icon v-if="validatedPayrolls" icon="$check_circle" /> -->
                            </v-col>

                            <!-- // ** expand icon -->
                            <v-col cols="6" class="align-center pa-0">
                                <v-btn-icon
                                    :icon="
                                        longGlobalCommentExpand
                                            ? '$fa-chevron-up'
                                            : '$fa-chevron-down'
                                    "
                                    data-cy="CheckBankReconciliation-commentaires"
                                    @click="longGlobalCommentExpand = !longGlobalCommentExpand"
                                    style="width: 40px"
                                    class="d-inline px-2"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-card-text v-if="longGlobalCommentExpand" transition="longGlobalCommentExpand">
                    <!-- <v-expand-transition no-gutters v-show="longGlobalCommentExpand"> -->
                    <v-card-text class="px-4">
                        <v-textarea
                            v-model="longComment"
                            :disabled="closedPeriod || validated"
                            auto-grow
                            style="border: 1px #ededed solid"
                            outlined
                        />
                    </v-card-text>

                    <v-row>
                        <v-col style="padding-bottom: 0">
                            <v-card-title
                                style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                            >
                                <v-spacer />

                                <!-- // ** Store data -->
                                <v-btn
                                    v-if="closedPeriod || validated"
                                    disabled
                                    rounded
                                    class="btn btn_blue"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                                <v-btn
                                    v-else
                                    rounded
                                    class="btn btn_blue"
                                    @click.stop="storeComments()"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                            </v-card-title>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <!-- // ++ shortComment -->
            <v-card
                elevation="0"
                style="background-color: white; border-radius: 25px"
                class="pa-6 mt-4"
            >
                <v-row>
                    <!-- // ** title ************** -->
                    <!-- <v-col cols="11" class="subtitle-2"> -->
                    <v-col cols="5" class="ma-auto">
                        <v-card-title class="ma-0 pa-0">
                            <h5 class="pl-4">Commentaires synthétiques</h5>
                        </v-card-title>
                    </v-col>

                    <v-spacer />

                    <!-- // ** icons *************** -->
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-row>
                            <v-col cols="6" class="align-center pa-0">
                                <!-- <v-icon v-if="validatedPayrolls" icon="$check_circle" /> -->
                            </v-col>

                            <!-- // ** expand icon -->
                            <v-col cols="6" class="align-center pa-0">
                                <v-btn-icon
                                    :icon="
                                        shortGlobalCommentExpand
                                            ? '$fa-chevron-up'
                                            : '$fa-chevron-down'
                                    "
                                    @click="shortGlobalCommentExpand = !shortGlobalCommentExpand"
                                    style="width: 40px"
                                    class="d-inline px-2"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-card-text v-if="shortGlobalCommentExpand" transition="shortGlobalCommentExpand">
                    <v-card-text class="px-4">
                        <v-textarea
                            v-model="shortComment"
                            :disabled="closedPeriod || validated"
                            auto-grow
                            style="border: 1px #ededed solid"
                            outlined
                        />
                    </v-card-text>

                    <v-row>
                        <v-col style="padding-bottom: 0">
                            <v-card-title
                                style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                            >
                                <v-spacer />

                                <!-- // ** Store data -->
                                <v-btn
                                    v-if="closedPeriod || validated"
                                    disabled
                                    rounded
                                    class="btn btn_blue"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                                <v-btn
                                    v-else
                                    rounded
                                    class="btn btn_blue"
                                    @click.stop="storeComments()"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                            </v-card-title>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <Chat
                :auditCheckAccountingPeriodKey="chatId"
                v-if="openChat"
                v-bind:chatTitle="'Chat'"
            />

            <AuditCheckDocumentsManager
                v-model="dialogAuditCheckDocumentsManager"
                v-if="dialogAuditCheckDocumentsManager"
                :disabled="loading || dataLoading || !accountingPeriod"
                :companyId="companyId"
                :documentToDisplay="documentToDisplay"
                :connectedDocuments="connectedDocuments || []"
                :acKey="acKey"
                :auditCheckResult="auditCheckResult || {}"
                :accountingPeriodId="accountingPeriodId || undefined"
                :alreadyLinkedDoc="alreadyLinkedDoc"
                @upsertedAuditCheckResult="upsertedACR"
                @resetDialogData="
                    alreadyLinkedDoc = false;
                    documentToDisplay = {};
                "
            />

            <oss-dialog
                v-model="displayActivityDialog"
                v-if="displayActivityDialog"
                title="Activité"
                valid-title="Fermer"
                @valid="displayActivityDialog = false"
                @close="displayActivityDialog = false"
                min-width="60vw"
            >
                <UsersActivitiesHistory
                    :auditCheckKey="acKey"
                    :accountingPeriodId="accountingPeriodId"
                >
                </UsersActivitiesHistory>
            </oss-dialog>
            <!-- // ** OD -->
            <!-- :accountingItemType="'MISCELLANEOUS_OPERATION'" -->
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";
import { sumBy } from "lodash";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

import AccountableAccountBalanceDetail from "../AccountableAccountBalanceDetail.vue";
import { CheckBase } from "./CheckBase";
import GeneralLedger from "../GeneralLedger2.vue";
import ossDataTable from "../ossComponents/ossDataTable2.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import Chat from "../chat/Chat.vue";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import CREATE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/UpsertBankAccountBalance.gql";
import SET_USE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/SetUseBankAccountBalance.gql";
import DELETE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/DeleteBankAccountBalance.gql";

import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import { Component, Prop, toNative, Watch } from "vue-facing-decorator";
import { CheckBankReconciliationDTO } from "./CheckBankReconciliation.dto";
import { getDBFormattedStartDate } from "@/services/dateServices";

@Component({
    components: {
        AccountableAccountBalanceDetail,
        GeneralLedger,
        ossDataTable,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
    }
})
export class CheckBankReconciliation extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    loading: boolean = false;
    dataLoading: boolean = true;
    // withAccountingPeriod: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;

    refreshKey = 0;

    allAreSelected: boolean = false;

    // accountingPeriodEnd: string = ""

    company: any = {};

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    noResults: boolean = false;
    validated: boolean = false;
    longComment: string = "";
    shortComment: string = "";
    commentsACRId: string = "";

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: Array<any> = [];
    previousPeriodDocuments: any = {};
    nextPeriodDocuments: any = {};

    bankAccountsExpand: Array<any> = [];
    balancesExpand: Array<any> = [];
    manualJustificationExpand: Array<any> = [];
    bankAccount512000Expand: Array<any> = [];
    bankAccount589999Expand: Array<any> = [];
    commentExpand: Array<any> = [];
    shortCommentExpand: Array<any> = [];
    generalLedgerExpand: boolean = false;
    longGlobalCommentExpand: boolean = false;
    shortGlobalCommentExpand: boolean = false;

    formIsValid: boolean = false;

    deleteBankReconciliationDialog: boolean = false;
    deleteAllSelectionnedBankReconciliationDialog: boolean = false;
    toDeleteBankBalance_BankAccount: any;
    toDeleteBankBalanceId: string = "";
    // toDeleteBankReconciliationIndex : any
    selectedBankReconciliationCheckBox = [];

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    // get selectedCompany() {
    //     return this.$store.getters.getCompany(this.companyId);
    // }
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    // ** AccountableAccountBalanceDetail
    accountableAccountInfo(bankAccountName, accountableAccountName) {
        return {
            name: accountableAccountName,
            bankAccountType: "BANK",
            bankAccountName: bankAccountName,
        };
    }

    accountingTransactions: Array<any> = [];

    withoutLettering: boolean = true;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    newManualBalanceDialog: boolean = false;

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    // ///////// CUSTOMERS SETTINGS /////////////////
    // acKey: string = "f6ckVK5uLXpKyft8JwArURpv"

    // ////////////////////////////////////////////////

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // afterAccountingPeriodFound() {
    // }

    @Watch("bankAccounts", { immediate: true, deep: true })
    updateNestedValues() {
        this.bankAccounts.forEach((bankAccount) => {
            // if (!bankAccount.justificationLines?.length) {
            //     this.addEmptyRow(bankAccount)
            // }

            if (bankAccount.justificationLines?.length) {
                bankAccount.manualJustification = mathFix(
                    sumBy(bankAccount.justificationLines, "debit") -
                        sumBy(bankAccount.justificationLines, "credit"),
                    2,
                );
            } else {
                bankAccount.manualJustification = 0;
            }
            bankAccount.balanceReconciliationFront = mathFix(
                bankAccount.balanceReconciliation + bankAccount.manualJustification,
                2,
            );

            if (bankAccount.balanceReconciliationFront && !bankAccount.justificationLines?.length) {
                if (!bankAccount.justificationLines?.length) {
                    this.addEmptyRow(bankAccount);
                }
            }

            bankAccount.accountingTheoreticBalance = mathFix(
                bankAccount.generalLedgerBalance + bankAccount.balance589999,
                2,
            );

            bankAccount.validated = !bankAccount.balanceReconciliationFront || false;
        });
    }

    headersBalancesTable: any = [
        { title: "", key: "checkbox", width: "64px", sortable: false },
        { title: "Date", key: "date", width: "auto", sortable: false },
        { title: "Type de relevé", key: "type", width: "auto", sortable: false },
        { title: "Solde Compta", key: "glBalance", align: "end", width: "auto", sortable: false },
        { title: "Solde Relevé", key: "balance", align: "end", width: "auto", sortable: false },
        { title: "Ecart", key: "difference", align: "end", width: "auto", sortable: false },
        // { title: "Origine de l'écart", key: "deltaPreviousMonth", align: "end", width: "auto", sortable: false },
        { title: "", key: "actions", align: "right", sortable: false },
    ];

    headersBankAccounts: any = [
        { title: "", key: "", width: "64px", sortable: false },
        { title: "Compte", key: "bankAccount.name" },
        { title: "Solde Comptable", key: "generalLedgerBalance", align: "right" },
        { title: "Solde Relevé", key: "importedBalance", align: "right" },
        { title: "Justificatifs manuels", key: "manualJustification", align: "right" },
        { title: "Écart", key: "balanceReconciliationFront", align: "right" },
        { title: "Supprimer", key: "", align: "center", sortable: false },
        { title: "Ecart nul", key: "validated", align: "center", sortable: false },
    ];

    // ++++++++++++++++++ ACCOUNTING LINES and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));

                    // ** not necessary in this control
                    // this.accountableAccountsFilter = [...this.items.accountableAccounts, ...this.items.usefulsAccountableAccounts]
                    // this.excludedAccountableAccountFilter = [...this.items.excludedAccountableAccounts, ...this.items.excludedUsefulsAccountableAccounts]

                    // ** bankAccounts
                    if (this.auditItems?.bankAccounts?.length) {
                        const bankAccounts = this.auditItems.bankAccounts;

                        for (const [indexBA, bankAccount] of bankAccounts.entries()) {
                            bankAccount.auditCheckResultId = bankAccount.auditCheckResults?.[0]?.id;

                            const acrData =
                                bankAccount.auditCheckResults?.[0]?.data?.[0] || undefined;
                            bankAccount.comment = acrData?.comment || "";
                            bankAccount.shortComment = acrData?.shortComment || "";
                            bankAccount.justificationLines = acrData?.justificationLines || [];
                            bankAccount.acrData = acrData || {};
                            if (bankAccount.validated) {
                                this.balancesExpand = [];
                                this.manualJustificationExpand = [];
                            }

                            for (const balance of bankAccount.balances) {
                                balance.newBalanceDate = "";
                                balance.newBalance = 0.0;
                                if (!balance.balances?.length) {
                                    balance.selected = {};
                                } else if (balance.balances.length === 1) {
                                    const selectedBalance = balance.balances[0];

                                    selectedBalance.checkboxId =
                                        bankAccount.id + "-" + balance.balances[0].id;
                                    selectedBalance.checked = false;
                                    selectedBalance.use = true;
                                    balance.selected = selectedBalance;
                                } else {
                                    let selectedBalance = balance.balances.find(
                                        (ba: any) => ba.use,
                                    );

                                    if (!selectedBalance) {
                                        selectedBalance = balance.balances[0];
                                    }

                                    selectedBalance.checkboxId =
                                        bankAccount.id + "-" + selectedBalance.id;
                                    selectedBalance.checked = false;

                                    balance.selected =
                                        balance.balances.find((ba: any) => ba.use) ||
                                        balance.balances[0];
                                }
                            }

                            // if (!bankAccount.justificationLines?.length) {
                            //     this.addEmptyRow(bankAccount)
                            // }

                            this.manualJustificationFunction(bankAccount, indexBA, "init");
                        }

                        this.bankAccounts = bankAccounts;
                    } else {
                        this.bankAccounts = [];
                    }

                    if (this.auditItems.generalLedgerOthers) {
                        this.generalLedgerOthers = this.auditItems.generalLedgerOthers;
                    }

                    // ** detailled ACRs are in bankAccounts

                    // ** commentsACR
                    if (this.auditItems.commentsACR?.id) {
                        this.auditCheckResult = this.auditItems.commentsACR;
                        this.commentsACRId = this.auditCheckResult.id;

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        if (this.auditCheckResult.results) {
                            this.results = this.auditCheckResult.results;
                        }

                        if (this.auditCheckResult?.data?.[0]) {
                            this.longComment = this.auditCheckResult.data[0].longComment;
                            this.shortComment = this.auditCheckResult.data[0].shortComment;
                            this.validated = this.auditCheckResult.data[0].validated || false;
                        }
                    } else {
                        this.commentsACRId = "";
                        this.longComment = "";
                        this.shortComment = "";
                        this.validated = false;
                    }
                } else {
                    this.auditItems = [];
                    this.bankAccounts = [];
                }

                this.loading = false;
                this.dataLoading = false;
            }
        },
    })
    auditItems: CheckBankReconciliationDTO;
    // auditItems: any;

    bankAccounts: Array<any> = [];

    generalLedgerOthers: number = 0;

    // ** not necessary in this control
    // accountableAccountsFilter: Array<any> = []

    // excludedAccountableAccountFilter: Array<any> = []

    bankAccountsExpanded = [];

    bankReconciliationChechBox: any[] = [];
    generalLedger: any[] = [];

    reviewed: number = 0;

    // ++ BANK ACCOUNTS
    isBankAccountExpanded(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.bankAccountsExpanded.indexOf(bankaccount.id);
        return index !== -1;
    }

    addRemoveBankAccountExpanded(bankaccount) {
        if (!bankaccount) {
            return;
        }
        const index = this.bankAccountsExpanded.indexOf(bankaccount.id);
        if (index === -1) {
            this.bankAccountsExpanded.push(bankaccount.id);
        } else {
            this.bankAccountsExpanded.splice(index, 1);
        }
    }

    // ++ BANK ACCOUNTS 512 GL
    bankAccountsGLExpand: Array<any> = [];
    isBankAccountGLExpanded(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.bankAccountsGLExpand.indexOf(bankaccount.id);
        return index !== -1;
    }

    addRemoveBankAccountGL(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.bankAccountsGLExpand.indexOf(bankaccount.id);
        if (index === -1) {
            this.bankAccountsGLExpand.push(bankaccount.id);
        } else {
            this.bankAccountsGLExpand.splice(index, 1);
        }
    }

    // ++ BANK ACCOUNTS BALANCES
    isBankAccountBalancesExpanded(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.balancesExpand.indexOf(bankaccount.id);
        return index !== -1;
    }

    addRemoveBankAccountBalances(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.balancesExpand.indexOf(bankaccount.id);
        if (index === -1) {
            this.balancesExpand.push(bankaccount.id);
        } else {
            this.balancesExpand.splice(index, 1);
        }
    }

    // ++ BANK ACCOUNTS MANUAL JUSTIFICATION
    isBankAccountManualJustificationExpanded(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.manualJustificationExpand.indexOf(bankaccount.id);
        return index !== -1;
    }

    addRemoveBankAccountManualJustification(bankaccount) {
        if (!bankaccount) {
            return;
        }

        const index = this.manualJustificationExpand.indexOf(bankaccount.id);
        if (index === -1) {
            this.manualJustificationExpand.push(bankaccount.id);
        } else {
            this.manualJustificationExpand.splice(index, 1);
        }
    }

    isBankAccount589999Expanded(item) {
        if (!item) {
            return;
        }

        const index = this.bankAccount589999Expand.indexOf(item.id);
        return index !== -1;
    }

    addRemoveBankAccount589999(item) {
        if (!item) {
            return;
        }

        const index = this.bankAccount589999Expand.indexOf(item.id);
        if (index === -1) {
            this.bankAccount589999Expand.push(item.id);
        } else {
            this.bankAccount589999Expand.splice(index, 1);
        }
    }

    isBankAccountCommentExpanded(item) {
        if (!item) {
            return;
        }

        const index = this.commentExpand.indexOf(item.id);
        return index !== -1;
    }

    addRemoveBankAccountComment(item) {
        if (!item) {
            return;
        }

        const index = this.commentExpand.indexOf(item.id);
        if (index === -1) {
            this.commentExpand.push(item.id);
        } else {
            this.commentExpand.splice(index, 1);
        }
    }

    isBankAccountShortCommentExpanded(item) {
        if (!item) {
            return;
        }

        const index = this.shortCommentExpand.indexOf(item.id);
        return index !== -1;
    }

    addRemoveBankAccountShortComment(item) {
        if (!item) {
            return;
        }

        const index = this.shortCommentExpand.indexOf(item.id);
        if (index === -1) {
            this.shortCommentExpand.push(item.id);
        } else {
            this.shortCommentExpand.splice(index, 1);
        }
    }

    disabledNewBalance(bankAccount) {
        if (!this.newManualBalanceDialog) return true;
        if (!bankAccount.newBalanceDate) return true;
        if (bankAccount.newBalance === null || bankAccount.newBalance === undefined) return true;

        const newBalanceDate = moment(bankAccount.newBalanceDate);
        const balanceData = bankAccount.balances.find((b) => moment(b.date).isSame(newBalanceDate));
        if (balanceData?.balances?.length) {
            const manualBalance = balanceData.balances.some((b) => b.type === "MANUAL");
            return !manualBalance;
        }
        return false;
    }

    async deleteSingleManualBalance(balanceId) {
        const deleted = await this.$apollo.mutate({
            mutation: DELETE_BANK_ACCOUNT_BALANCE,
            variables: {
                id: balanceId,
            },
        });

        // await this.createUserActivity("DELETE") // deprecated

        if (deleted) {
            this.toDeleteBankBalanceId = undefined;

            // ** not if fonction called by deleteAllManualBalances()
            if (this.selectedBankReconciliationCheckBox?.length === 1) {
                this.selectedBankReconciliationCheckBox = [];
            }

            this.deleteBankReconciliationDialog = false;
            this.refresh();
        }
    }

    async deleteAllManualBalances() {
        let promises = [];
        for (const i of this.selectedBankReconciliationCheckBox) {
            // bankAccountIndex-balanceIndex
            const [bankAccountId, balanceId] = i.split("-");
            const bankAccount = this.bankAccounts.find((ba) => ba.id == bankAccountId);
            promises.push(this.deleteSingleManualBalance(balanceId));

            if (promises.length > 10) {
                const done = await Promise.all(promises);
                if (done) {
                    promises = [];
                }
            }
        }
        if (promises.length) {
            const done = await Promise.all(promises);
            if (done) {
                this.deleteAllSelectionnedBankReconciliationDialog = false;
                this.selectedBankReconciliationCheckBox = [];
            }
        } else {
            this.deleteAllSelectionnedBankReconciliationDialog = false;
            this.selectedBankReconciliationCheckBox = [];
        }
    }

    openBankReconciliationDialog(bankAccount, balanceId) {
        this.toDeleteBankBalanceId = balanceId;
        this.toDeleteBankBalance_BankAccount = bankAccount;
        this.deleteBankReconciliationDialog = true;
    }

    manualBankAccountBalances(bankAccount) {
        return bankAccount.balances.filter((b) => b.selected?.type === "MANUAL");
    }

    selectAll(bankAccount) {
        debugger;
        const manualBalances = this.manualBankAccountBalances(bankAccount);

        console.log("🚀 - selectAll - manualBalances:", manualBalances);
        if (this.selectedBankReconciliationCheckBox.length) {
            this.removeOtherBankAccountsFromSelected(bankAccount);
        }
        if (this.selectedBankReconciliationCheckBox.length !== manualBalances.length) {
            for (const i in manualBalances) {
                this.selectedBankReconciliationCheckBox.push(manualBalances[i].selected.checkboxId);
                manualBalances[i].selected.checked = true;
            }
            this.allAreSelected = true;
        } else {
            this.selectedBankReconciliationCheckBox = [];
            this.allAreSelected = false;
            manualBalances.forEach((b) => (b.selected.checked = false));
        }
        this.refreshKey++;
    }

    selectBalance(bankAccount, balance) {
        const checkboxId = balance.selected.checkboxId;

        if (this.selectedBankReconciliationCheckBox.length) {
            this.removeOtherBankAccountsFromSelected(bankAccount);
        }
        const index = this.selectedBankReconciliationCheckBox.indexOf(checkboxId);

        if (index === -1) {
            balance.selected.checked = true;
            this.selectedBankReconciliationCheckBox.push(checkboxId);
        } else {
            this.selectedBankReconciliationCheckBox.splice(index, 1);
            balance.selected.checked = false;
        }

        this.refreshKey++;
    }

    removeOtherBankAccountsFromSelected(bankAccount) {
        this.selectedBankReconciliationCheckBox = this.selectedBankReconciliationCheckBox.filter(
            (i) => i.split("-")[0] === bankAccount.id,
        );
    }

    async addNewBalance(bankAccount) {
        const newManualBalance = await this.$apollo.mutate({
            mutation: CREATE_BANK_ACCOUNT_BALANCE,
            variables: {
                baId: bankAccount.id,
                balance: {
                    date: getDBFormattedStartDate(bankAccount.newBalanceDate),
                    balance: bankAccount.newBalance,
                    type: "MANUAL",
                },
            },
        });

        // await this.createUserActivity("CREATE") // deprecated

        if (newManualBalance) {
            this.newManualBalanceDialog = false;
            this.refresh();
        }
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger;
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    showBTs(bankAccount, balanceIndex) {
        if (balanceIndex >= 0) {
            const balance = bankAccount.balances[balanceIndex];
            const previousBalance = bankAccount.balances[balanceIndex - 1];
            const endDate = previousBalance?.date
                ? moment(previousBalance.date).add(1, "days").format("YYYY-MM-DD")
                : moment(this.accountingPeriod.start).format("YYYY-MM-DD");
            const balanceDate = moment(balance.date).format("YYYY-MM-DD");

            if (bankAccount.id && balance.date && endDate) {
                const params: any = {
                    bankAccountId: bankAccount.id,
                    beginDate: endDate,
                    endDate: balanceDate,
                };

                this.$router.push({
                    name: "bank",
                    query: params,
                });
            }
        }
    }

    difference(balance, glBalance) {
        if (glBalance === undefined || glBalance === null) {
            debugger; // may not be empty
            return "-";
        }
        if (balance === undefined || balance === null) return "-";
        const diff = balance - glBalance;

        return newCommonFormatCurrency(diff);
    }

    getDuplicated(item, bal) {
        return item.balances.filter(
            (ba) => moment(ba.date).isSame(moment(bal.date)) && ba.id !== bal.id,
        );
    }

    differenceColor(balance1, balance2) {
        if (balance1 === undefined) return "color:red;";
        if (balance2 === undefined) return "color:red;";
        if (Math.abs(balance1 - balance2) > 1e-2) return "color:red;";
        return "color:green;";
    }

    // deltaPreviousMonth(balances, i) {
    //     if (i === 0) {
    //         return 0;
    //     }
    //     if (balances?.[i] && !!balances[i]?.selected?.balance && balances[i]?.glBalance) {
    //         const difference = mathFix(balances[i].selected.balance - balances[i].glBalance, 2);
    //         if (!difference) {
    //             return 0
    //         }
    //         const pmDifference = mathFix(balances[i - 1].selected.balance - balances[i - 1].glBalance, 2);
    //         return difference - pmDifference;
    //     }
    //     return 0
    // }

    computeBalancesLoading = false;

    getBalanceTypeText(item) {
        switch (item.type) {
            case "BUDGET_INSIGHT":
                return "Import automatique";
            case "EBICS_JE_DECLARE":
                return "EBICS JE Declare";
            case "EBICS_SO_BANK":
                return "EBICS SO Bank";
            case "EBICS_MANUAL":
                return "EBICS Manual";
            case "BANK_STATEMENT":
                return "Relevé bancaire (pdf)";
            case "MANUAL":
                return "Manuel";
            case "IMPORT_TXT":
                return "Relevé bancaire (texte)";
            case "IMPORT_FEC":
                return "Import fichier comptable";
            case "COMPUTE_CARRY_FORWARD":
                return "AN";
        }
        debugger; // git-ignore
        return "XXX";
    }

    async selectedBalanceChanged(balance) {
        this.$apollo.mutate({
            mutation: SET_USE_BANK_ACCOUNT_BALANCE,
            variables: {
                balanceId: balance.selected.id,
            },
        });
        this.refresh();
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        if (acrId) {
            await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                variables: { id: acrId },
            });

            this.refresh();
        }
    }

    async createReconciliationData(bankAccount) {
        const acrData = [];

        acrData.push({
            justificationLines: bankAccount.justificationLines || [],
            comment: bankAccount.comment,
            shortComment: bankAccount.shortComment,
            validated: !bankAccount.balanceReconciliationFront || false,
        });
        let auditCheckResultVariables: any = {};

        if (this.acKey && this.companyId && bankAccount.id && this.accountingPeriodId && acrData) {
            auditCheckResultVariables = {
                id: bankAccount.auditCheckResultId || "",
                key:
                    this.acKey +
                    "_" +
                    this.companyId +
                    "_" +
                    bankAccount.id +
                    "_" +
                    this.accountingPeriodId,
                companyId: this.companyId,
                status: "UNKNOWN",
                // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                bankAccountCreateConnection: { connect: { id: bankAccount.id } },
                bankAccountUpdateConnection: { connect: { id: bankAccount.id } },
                // documentCreateConnection:
                // documentUpdateConnection:
                // accountingLineCreateConnection: {connect: {id: currentAlAcrData.alId}},
                // accountingLineUpdateConnection: {connect: {id: currentAlAcrData.alId}},
                data: JSON.parse(JSON.stringify(acrData)),
                deleteDocuments: [],
                documents: [],
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                auditCheckKey: this.acKey,
            };
        }

        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity("CREATE") // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();
        // this.refreshGeneralLedger++
        // this.refreshGeneralLedger70NL++
        // this.refreshGeneralLedger411AN++
        // this.refreshGeneralLedger411NL++
    }

    async storeComments(action = undefined) {
        const commentsACRKey = this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId;

        const data = [
            {
                shortComment: this.shortComment || "",
                longComment: this.longComment || "",
                validated: this.validated || false,
            },
        ];

        const upsertVariables: any = {
            id: this.commentsACRId || "",
            key: commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data,
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // await this.createUserActivity(action) // deprecated

        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger; // git-ignore
        }
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.storeComments("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.storeComments("UPDATE");
        }
    }

    // initialiseCompany() {
    // this.accountableAccounts = []
    // }

    onQueryDone() {}

    // bankAccount512000OnQueryDone(data) {
    // ** value is already received from backend
    // const bankAccount = this.bankAccounts.find(ba => ba.name === data.item.bankAccountName)

    // if (bankAccount) {
    //     bankAccount.balance512000 = data.totalBalance || 0
    // }
    // }

    // bankAccount589999OnQueryDone(data) {
    //     const bankAccount = this.bankAccounts.find(ba => ba.name === data.item.bankAccountName)
    //     if (bankAccount) {
    //         bankAccount.balance589999 = data.totalBalance || 0
    //         debugger
    //     }
    // }

    defaultRow: any = {
        date: "",
        wording: "",
        reason: "",
        debit: 0,
        credit: 0,
    };

    addEmptyRow(bankAccount) {
        const row = JSON.parse(JSON.stringify(this.defaultRow));
        row.date = this.accountingPeriod?.end
            ? this.formatDatePicker(this.accountingPeriod.end)
            : moment().format("YYYY-MM-DD");
        bankAccount.justificationLines.push(row);
    }

    deleteRow(bankAccount, index) {
        if (bankAccount.justificationLines?.[index]) {
            bankAccount.justificationLines.splice(index, 1);
            this.manualJustificationFunction(bankAccount, index - 1);
            this.createReconciliationData(bankAccount);

            // if (bankAccount.justificationLines?.length === 0) {
            //     this.addEmptyRow(bankAccount)
            // }
            // this.refresh()
        }
    }

    manualJustificationFunction(bankAccount, index: number = -1, debitOrCredit: string = "") {
        if (index > -1 && !!debitOrCredit && debitOrCredit !== "init") {
            if (debitOrCredit === "debit" && bankAccount.justificationLines?.[index]?.debit > 0) {
                bankAccount.justificationLines[index].credit = 0;
            }
            if (debitOrCredit === "credit" && bankAccount.justificationLines?.[index]?.credit > 0) {
                bankAccount.justificationLines[index].debit = 0;
            }

            bankAccount.manualJustification = mathFix(
                sumBy(bankAccount.justificationLines, "debit") -
                    sumBy(bankAccount.justificationLines, "credit"),
                2,
            );
        } else {
            bankAccount.manualJustification = 0;
        }

        // bankAccount.balanceReconciliationFront = mathFix((bankAccount.balanceReconciliation + bankAccount.manualJustification), 2)

        // bankAccount.accountingTheoreticBalance = mathFix((bankAccount.generalLedgerBalance + bankAccount.balance589999), 2)

        // bankAccount.validated = !bankAccount.balanceReconciliationFront || false
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
        return false;
    }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (this.bankAccounts?.length) {
            const notValidatedBankAccount = this.bankAccounts.find((ba) => !ba.validated);
            if (notValidatedBankAccount) {
                if (this.validated) {
                    this.validated = false;
                    this.storeComments();
                }
                return true;
            }
        }
        return false;
    }

    formIsValid2(bankAccount) {
        if (bankAccount.justificationLines?.length) {
            if (bankAccount.justificationLines.some((line) => !line.debit && !line.credit)) {
                return false;
            }
            if (bankAccount.justificationLines.some((line) => !moment(line.date).isValid())) {
                return false;
            }
            if (bankAccount.justificationLines.some((line) => !line.wording?.length)) {
                return false;
            }
        }
        return true;
    }
}

export default toNative(CheckBankReconciliation);
</script>
